import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonUtilities } from '../assets/js/common-utilities';

import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';

//prime ng start
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChipsModule } from 'primeng/chips';
import { FieldsetModule, } from 'primeng/fieldset';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TabViewModule } from 'primeng/tabview';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { MenuModule } from 'primeng/menu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { EditorModule } from 'primeng/editor';
import { HotkeyModule } from 'angular2-hotkeys';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PaginatorModule } from 'primeng/paginator';
import { DatePipe } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { MomentModule } from 'ngx-moment';
//prime ng end

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { AllComponentsComponent } from './all-components/all-components.component';


//developer component start
import { HomeComponent } from './home/home.component';
import { AgentEnquiryComponent } from './agent/agent-enquiry/agent-enquiry.component';
// import { CCustomerComponent } from './Customer/c-customer/c-customer.component';

import { CCustomerComponent } from './Components/Customer/c-customer/c-customer.component';
import { VCustomerComponent } from './Components/Customer/v-customer/v-customer.component';
import { CCustomerinformationComponent } from './Components/CustomerInformation/c-customerinformation/c-customerinformation.component';
import { VCustomerinformationComponent } from './Components/CustomerInformation/v-customerinformation/v-customerinformation.component';
import { CDashboardComponent } from './Components/Dashboard/c-dashboard/c-dashboard.component';
import { CServicelocationComponent } from './Components/ServiceLocation&Operations/c-servicelocation/c-servicelocation.component';
import { CStockkeepingunitComponent } from './Components/StockKeepingUnit/c-stockkeepingunit/c-stockkeepingunit.component';
import { CCostingComponent } from './Components/Costing/c-costing/c-costing.component';
import { CExistingvendorComponent } from './Components/ExistingVendor/c-existingvendor/c-existingvendor.component';
import { CTradereferenceComponent } from './Components/TradeReference/c-tradereference/c-tradereference.component';
import { CPrequotesignoffComponent } from './Components/Pre-QuoteSignOff/c-prequotesignoff/c-prequotesignoff.component';
import { CPrequotecontractconversionComponent } from './Components/Pre-Quote to Contract Conversion/c-prequotecontractconversion/c-prequotecontractconversion.component';
import { ReportapprovalComponent } from './Components/ReportApproval/reportapproval/reportapproval.component';
import { PrequoteComponent } from './Components/Pre_Quote/prequote/prequote.component';
import { VPrequoteComponent } from './Components/Pre_Quote/v-prequote/v-prequote.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ReportComponent } from './Components/Report/report/report.component';
import { VApprovalComponent } from './Components/Approval/v-approval/v-approval.component';
import { LandingpageComponent } from './Components/landingpage/landingpage.component';
import { VPrequotecontractconversionComponent } from './Components/Pre-Quote to Contract Conversion/v-prequotecontractconversion/v-prequotecontractconversion.component';
import { ViewprequoteComponent } from './Components/Pre_Quote/viewprequote/viewprequote.component';
import { CCustomerContractComponent } from './Components/CustomerContract/c-customer-contract/c-customer-contract.component';
import { VCustomerContractComponent } from './Components/CustomerContract/v-customer-contract/v-customer-contract.component';

// import { MatTabChangeEvent } from '@angular/material';
// import { VCustomerComponent } from './Customer/v-customer/v-customer.component';
//developer component end

@NgModule({
  declarations: [
    
    AppComponent,
    HeaderComponent,
    LeftMenuComponent,
    AllComponentsComponent,
    HomeComponent,
    AgentEnquiryComponent,
    CCustomerComponent,
    // CManagecustomerComponent,
    // VManagecustomerComponent,
    VCustomerComponent,
    CCustomerinformationComponent,
    VCustomerinformationComponent,
    CDashboardComponent,
    CServicelocationComponent,
    CStockkeepingunitComponent,
    CCostingComponent,
    CExistingvendorComponent,
    CTradereferenceComponent,
    CPrequotesignoffComponent,
    CPrequotecontractconversionComponent,
    ReportapprovalComponent,
    PrequoteComponent,
    VPrequoteComponent,
    ReportComponent,
    VApprovalComponent,
    LandingpageComponent,
    VPrequotecontractconversionComponent,
    ViewprequoteComponent,
    CCustomerContractComponent,
    VCustomerContractComponent
  ],
  imports: [
    FormsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    TableModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    ProgressBarModule,
    EditorModule,
    InputTextModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    RadioButtonModule,
    InputNumberModule,
    ConfirmDialogModule,
    InputTextareaModule,
    BrowserAnimationsModule,
    ChipsModule,
    FieldsetModule,
    AutoCompleteModule,
    TabViewModule,
    InputMaskModule,
    TooltipModule,
    InputSwitchModule,
    CheckboxModule,
    MenuModule,
    PanelMenuModule,
    PasswordModule,
    ProgressSpinnerModule,
    HotkeyModule.forRoot(),
    ImageCropperModule,
    PaginatorModule,
    DragDropModule,
    ReactiveFormsModule,
    ProgressSpinnerModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBpZ_MTPEM5X2mpYPLoxKynwtunce3gEJ4",
      libraries: ["places"]
    }),
    NgIdleKeepaliveModule.forRoot(), 
    MomentModule,
    // MatTabChangeEvent 
  ],
  providers: [MessageService, ConfirmationService, CommonUtilities, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
